/**
 * Bulk report background send — types shared by the browser (the print page,
 * the batches panel) and the server (the batch worker and routes).
 */

export type ReportFormat = 'pdf' | 'html';

/** What the worker asks the print page to do for one bill. */
export type SendOneInput = {
  billId: string;
  recipients: string[];
  templateId: string | null;
  accountId: string;
  format: ReportFormat;
};

export type SendOneResult =
  | { state: 'sent'; sendId: string }
  | { state: 'skipped'; reason: string }
  | { state: 'failed'; error: string };

export type BatchStatus = 'queued' | 'running' | 'paused' | 'cancelled' | 'done' | 'partial' | 'failed';
export type BatchItemStatus = 'pending' | 'running' | 'sent' | 'failed' | 'skipped' | 'cancelled';

export const ACTIVE_BATCH_STATUSES: readonly BatchStatus[] = ['queued', 'running', 'paused'];

export type ReportBatchSummary = {
  id: string;
  status: BatchStatus;
  format: ReportFormat;
  total: number;
  sent: number;
  failed: number;
  skipped: number;
  liveWorkers: number;
  error: string | null;
  requestedBy: string;
  /** Display name of whoever started the batch — resolved server-side from the profiles table. */
  requestedByName: string;
  createdAt: string;
  startedAt: string | null;
  finishedAt: string | null;
  /** Latest heartbeat of any worker on the batch (null before one has joined). */
  heartbeatAt: string | null;
  /** Failed bills a resend would still queue: not sent since, not already in a sending batch. */
  resendable: number;
};

export type ReportBatchItemView = {
  id: string;
  billId: string;
  status: BatchItemStatus;
  error: string | null;
  attempts: number;
  nmi: string | null;
  clientName: string | null;
  billFrom: string | null;
  billTo: string | null;
};
